// extracted by mini-css-extract-plugin
export var text = "_bx-0";